// Firebase app + Auth bootstrap (Identity Platform). Phase 3 of the Go/Cloud
// migration replaces Supabase Auth with Firebase Auth — this file is auth-only
// on purpose: data still flows exclusively through the REST API (apiClient),
// never Firestore.
import { initializeApp } from "firebase/app"
import { connectAuthEmulator, getAuth } from "firebase/auth"

const isFirebaseConfigured = !!(import.meta.env.VITE_FIREBASE_API_KEY && import.meta.env.VITE_FIREBASE_PROJECT_ID)

if (!isFirebaseConfigured) {
  const message = "Firebase is not configured. Set VITE_FIREBASE_API_KEY and VITE_FIREBASE_PROJECT_ID in .env."
  if (import.meta.env.DEV) {
    console.error(`[firebase] ${message}`)
  } else {
    throw new Error(message)
  }
}

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "demo-key",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "demo.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "demo-project",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "demo.appspot.com",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "123456789",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:123456789:web:demo",
}

const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)

// Local development stack only (scripts/dev/stack.sh): point Auth at the dev
// auth stub instead of Google. The stub speaks the Identity Toolkit endpoints
// the SDK calls in emulator mode and mints real RS256 ID tokens that the Go API
// verifies against its published certificate — so sign-up, login and household
// sharing all work offline, against local Postgres, with nothing written to the
// production project. `import.meta.env.DEV` is a build-time constant, so this
// whole block is tree-shaken out of any production build.
if (import.meta.env.DEV && import.meta.env.VITE_USE_FIREBASE_EMULATOR === "true") {
  const url = import.meta.env.VITE_FIREBASE_EMULATOR_URL || "http://localhost:9099"
  connectAuthEmulator(auth, url, { disableWarnings: true })
  console.info(`[firebase] auth emulator: ${url}`)
}
